import React from 'react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { Link } from 'react-router-dom';

interface SubMenuItem {
  label: string;
  href: string;
}

interface MenuItem {
  label: string;
  href?: string;
  subItems?: SubMenuItem[];
}

interface DesktopNavigationProps {
  menuItems: MenuItem[];
  currentPath: string;
  activeDropdown: string | null;
  dropdownRef: React.RefObject<HTMLDivElement | null>;
  onToggleDropdown: (label: string) => void;
  isActiveItem: (item: MenuItem) => boolean;
}

const DesktopNavigation: React.FC<DesktopNavigationProps> = ({
  menuItems,
  currentPath,
  activeDropdown,
  dropdownRef,
  onToggleDropdown,
  isActiveItem,
}) => {
  return (
    <nav
      className="hidden md:flex items-center justify-center space-x-1"
      ref={dropdownRef}
    >
      {menuItems.map((item) => (
        <div key={item.label} className="relative">
          {item.href && !item.subItems ? (
            <Link
              to={item.href}
              className={`px-6 py-3 rounded-lg text-base font-medium transition-colors duration-200 cursor-pointer ${
                isActiveItem(item)
                  ? 'bg-primary-500 text-secondary-500'
                  : 'text-black hover:opacity-80'
              }`}
            >
              {item.label}
            </Link>
          ) : item.href && item.subItems ? (
            <div
              className={`flex items-center rounded-lg transition-colors duration-200 ${
                isActiveItem(item)
                  ? 'bg-primary-500 text-secondary-500'
                  : 'text-black hover:opacity-80'
              }`}
            >
              <Link
                to={item.href}
                className="pl-6 py-3 text-base font-medium cursor-pointer"
              >
                {item.label}
              </Link>
              <button
                onClick={() => onToggleDropdown(item.label)}
                className="pl-2 pr-6 py-3 text-base font-medium transition-colors duration-200 cursor-pointer"
              >
                <ChevronDownIcon
                  className={`w-4 h-4 transition-transform duration-200 ${
                    activeDropdown === item.label ? 'rotate-180' : ''
                  }`}
                />
              </button>
            </div>
          ) : (
            <button
              onClick={() => onToggleDropdown(item.label)}
              className={`px-6 py-3 rounded-lg text-base font-medium transition-colors duration-200 flex items-center space-x-1 cursor-pointer ${
                isActiveItem(item)
                  ? 'bg-primary-500 text-secondary-500'
                  : 'text-black hover:opacity-80'
              }`}
            >
              <span>{item.label}</span>
              <ChevronDownIcon
                className={`w-4 h-4 transition-transform duration-200 ${
                  activeDropdown === item.label ? 'rotate-180' : ''
                }`}
              />
            </button>
          )}

          {/* Dropdown Menu */}
          {item.subItems && activeDropdown === item.label && (
            <div className="absolute top-full left-0 mt-1 w-56 bg-primary-500 text-secondary-500 rounded-lg shadow-lg py-2 z-50 border border-primary-500">
              {item.subItems.map((subItem) => (
                <Link
                  key={subItem.label}
                  to={subItem.href}
                  className={`block px-6 py-3 text-base transition-colors duration-200 cursor-pointer text-secondary-500 ${
                    currentPath === subItem.href
                      ? 'bg-primary-500 border-r-2 border-r-secondary-500'
                      : ''
                  }`}
                >
                  {subItem.label}
                </Link>
              ))}
            </div>
          )}
        </div>
      ))}
    </nav>
  );
};

export default DesktopNavigation;
